// extracted by mini-css-extract-plugin
module.exports = {"container":"Doctor_container__KqjBk","body":"Doctor_body__pijOS","box":"Doctor_box__54QZD","header":"Doctor_header__3It52","wrapheader":"Doctor_wrapheader__1Xtju"};